export const NON_HOME_PATH_ROUTE =
  process.env.REACT_APP_ENV === 'personal' || process.env.REACT_APP_ENV === 'local' ? process.env.PUBLIC_URL : '';

export const STRIPE_EARNINGS_URL = 'https://connect.stripe.com/app/express#balances';
